import PropTypes from "prop-types"

import useMatchMedia from "./useMatchMedia"

/**
 * Uses media checker hoot and passes value as render props
 * @param       {function} children      Function to call as render props
 * @param       {string}   size          a valid css width unit
 * @param       {string}   matchCriteria a valid css media query crireria
 * @constructor
 */
export default function MediaChecker({ children, size, matchCriteria }) {
  const matches = useMatchMedia(size, matchCriteria)
  return children(matches)
}

MediaChecker.propTypes = {
  children: PropTypes.func.isRequired,
  size: PropTypes.string,
  matchCriteria: PropTypes.string
}
